import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isPartnerAdminEmail } from "@/lib/adminAccess";

export default function AdminEmailRoute({ children }: { children: ReactNode }) {
  const { session, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Ladataan...</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/admin/login" replace />;
  }

  const email = (user?.email ?? "").trim().toLowerCase();
  if (!isPartnerAdminEmail(email)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
